module.exports = __webpack_public_path__ + "static/media/soldOut.046390c6.png";